import { routerReducer } from 'react-router-redux';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';

import app from './reducers/App';
import auth from './reducers/Auth';
import toggle from './reducers/Toggle';
import institution from './reducers/Institution';
import alert from './reducers/Alert';
import error from './reducers/Error';

import { reducer as formReducer } from 'redux-form'
//import signForm from './reducers/validator/SignForm';

const loggerMiddleware = createLogger;

export default function configureStore() {
  return createStore(
    combineReducers({
      app: app,
      auth: auth,
      toggle: toggle,
      institution: institution,
      alert: alert,
      error: error,
      form: formReducer,
      routing: routerReducer,
    }),
    applyMiddleware(
      thunkMiddleware,
      loggerMiddleware
    )
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js